import Spinner from '@xo-union/tk-component-spinner';

export default Spinner;